import _ from '@lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class ReviewEditDto extends IdentifiableDto {
	constructor() {
		super();

		/** @type {number} */
		this.felhasznalo = null;

		/** @type {number} */
		this.kerdes = null;

		/** @type {string} */
		this.gradualOutputLevelCorrespondence = null;

		/** @type {string} */
		this.reasoningLevel = null;

		/** @type {boolean} */
		this.clearQuestion = null;

		/** @type {string} */
		this.incorrectAnswersBelievable = null;

		/** @type {boolean} */
		this.grammarProblems = null;

		/** @type {string} */
		this.shouldBeDeleted = null;

		/** @type {string} */
		this.comments = null;
	}

	/**
	 * @typedef {Object} _ReviewEditDtoProps
	 * @property {string} felhasznalo
	 * @property {string} kerdes
	 * @property {string} gradualOutputLevelCorrespondence
	 * @property {string} reasoningLevel
	 * @property {string} clearQuestion
	 * @property {string} incorrectAnswersBelievable
	 * @property {string} grammarProblems
	 * @property {string} shouldBeDeleted
	 * @property {string} comments
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _ReviewEditDtoProps} ReviewEditDtoProps
	 */

	/**
	 *
	 * @param {ReviewEditDtoProps} props
	 * @returns {ReviewEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.felhasznalo = props.felhasznalo;
		this.kerdes = props.kerdes;
		this.gradualOutputLevelCorrespondence = props.gradualOutputLevelCorrespondence;
		this.reasoningLevel = props.reasoningLevel;
		this.clearQuestion = props.clearQuestion;
		this.incorrectAnswersBelievable = props.magincorrectAnswersBelievablearazatPlaintext;
		this.grammarProblems = props.grammarProblems;
		this.shouldBeDeleted = props.shouldBeDeleted;
		this.comments = props.comments;

		return this;
	}

	/**
	 *
	 * @param {string} key
	 * @returns {string}
	 */
	getAsString(key) {
		if (key === 'aktiv') {
			return !_.isUndefined(this.aktiv) && this.aktiv !== null ? (this.aktiv === 1 ? 'Aktív' : 'Inaktív') : '';
		}
		return super.getAsString(key);
	}
}

export default ReviewEditDto;